export default "__VITE_ASSET__2e7c6f67__"